var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canShowContent)?_c('div',{staticClass:"missing-translation-notification w-full mx-auto"},[_c('render-content',{attrs:{"content":_vm.internalCmsContent}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }